import {Component, OnInit, ViewChild} from '@angular/core';
import {OrderService} from "../../../../services/order.service";
import {DatePipe} from "@angular/common";
import {environment} from "../../../../environments/environment";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import {ShopService} from "../../../../services/shop.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import { Shop } from '../../../../models/shop.model';
import { UserService } from '../../../../services/user.service';
import { User } from '../../../../models/user.model';

@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss']
})
export class OrderItemComponent implements OnInit {
  @ViewChild('closebutton') closebutton;

  orderItems: any[] = [];
  orderItemsTMP: any[] = [];
  sorted = 1;
  url_photo: String;
  @ViewChild('deleteCommentModal') deleteCommentModal;

  /*
-----------------------------         for all page attribute    --------------------------------
*/
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  seller = false;
  pageNumber: number = 1;
  pageSize: number = 25;
  totalItems :any;
  cancelCommentForm: FormGroup;
  currentOrderItem : any;
  /*
  end for all page
   */

  beginDate: any = null;
  endDate: any = null;
  toCancel: any;
  searchText: any = "";

  constructor(private orderService:OrderService,     private fb: FormBuilder,
              private datePipe: DatePipe, private shopService:ShopService,
              private userService: UserService) { }
              
  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.loadOrderItem();
    this.cancelCommentForm = this.fb.group({
      'comment': new FormControl('', [Validators.required, Validators.minLength(10)]),
    });
  }
  
  isFilterByProduct: boolean = false;
  isFilterByService: boolean = false;
  isFilterByProductAndService: boolean = true;
  loadOrderItem() {
    this.searchText = this.search !== undefined ? this.search : '';
    this.orderService.allSellerOrderItems(this.pageNumber-1, this.pageSize, this.isFilterByProductAndService, this.isFilterByService, this.isFilterByProduct, this.beginDate, this.endDate, this.searchText, this.statusSearchText).subscribe((rs:any) => {
      this.orderItems = rs.content;
      this.totalItems = rs.totalElements;
      this.orderItems.map(value => {
        value.nbDays = this.calculateDaysBetweenDates(new Date(value.saveAt).toString())
        this.orderService.getCategoryNameByPostIddd(value.postId).subscribe(rest=>{
          value.categoryName = rest;
        });
      })
      // this.orderItems = this.orderItems.filter(or => or.itemType.toLowerCase() != "carte cadeaux");
    //  console.log("Liste des commandesss");
    //  console.log(this.orderItems);
      /*this.orderItems.forEach(item => {
        if(item.productID != null && item.productShopID != null) {
          this.shopService.getIdShopID(item.productShopID).subscribe(rs => {
            //console.log(rs);
            item.shop = rs;
          })
        }
        if(item.serviceID != null && item.serviceShopID != null) {
          this.shopService.getIdShopID(item.serviceShopID).subscribe(rs => {
            //console.log(rs);
            item.shop = rs;
          })
        }
      })*/
    });
  }


  sortTransactionsByDate(transactions :any[]) :any[]{
    return transactions.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateB - dateA; // Trie du plus récent au plus ancien
    });
  }

  searchFilter($event: KeyboardEvent) {
   // this.orderItems = [];
  
    
  }

  searchFilter_v1($event: KeyboardEvent) {
    this.searchText = this.search !== undefined ? this.search : '';
    this.loadOrderItem();
  }
  
  trier(columnName: keyof any) {
    this.sorted = -this.sorted;
    this.orderItems.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }

  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }
  // Récupération de la date de fin

  getEndDate(event){
    this.endDate=event.target.value;
  }

  filterOrderItems() {
    // console.log("test")
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.loadOrderItem();
    }

  }

  resetFilter() {
    this.statusSearchText = '';
    this.searchText = '';
    this.beginDate = null;
    this.endDate = null;
    this.loadOrderItem();
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.loadOrderItem();
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  calculateDaysBetweenDates(date: string): number {
    const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

    const today = new Date().getTime();
    const dateTimestamp = new Date(date).getTime();

    if (isNaN(today) || isNaN(dateTimestamp)) {
      throw new Error('Invalid date format. Please provide dates in the format: "yyyy-MM-dd".');
    }

    const differenceInMilliseconds = today - dateTimestamp;
    const daysDifference = Math.round(differenceInMilliseconds / ONE_DAY_IN_MILLISECONDS);

    return daysDifference;
  }

  disableOrderItemButtonClick = false;
  cancelOrder(co: any) {
    this.disableOrderItemButtonClick = true;
    this.toCancel = co;
      Swal.fire({
        title: 'Voulez-vous vraiment annulée cette commande ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonText: 'Non',
        confirmButtonText: 'Oui'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteCommentModal.nativeElement.click();
        }else{
          this.disableOrderItemButtonClick = false;
        }
      })
  }

  canceledCommentForm(){
    this.disableOrderItemButtonClick = false;
  }

  selectType(value: string) {
    if (value == "all") {
      this.isFilterByService = false;
      this.isFilterByProduct = false;
      this.isFilterByProductAndService = true;
      this.loadOrderItem();
    } else if (value == "service") {
        this.isFilterByService = true;
        this.isFilterByProduct = false;
        this.isFilterByProductAndService = false;
        this.loadOrderItem();
      } else {
        this.isFilterByService = false;
        this.isFilterByProduct = true;
        this.isFilterByProductAndService = false;
        this.loadOrderItem();
      }

    
  }
  statusSearchText = '';
  selectStatus(event: any) {
    let selectedStatus = event.target.value;
    if(selectedStatus == "all"){
      this.statusSearchText = '';
      this.loadOrderItem();
    }else{
      if(selectedStatus == "Livrée"){
        this.statusSearchText = "livré";
        this.loadOrderItem();
      }else if(selectedStatus == "Exécutée"){
        this.orderItems = this.orderItems.filter((t) => {
          return (t.state.toLowerCase() === "Exécuté".toLowerCase());
        });
      }else if(selectedStatus == "Nonlivrée"){
        this.statusSearchText = "Non livré";
        this.loadOrderItem();
      }else if(selectedStatus == "Nonexécutée"){
        this.statusSearchText = "Non exécuté";
        this.loadOrderItem();
      }else if(selectedStatus == "Annulée"){
        this.statusSearchText = "Annulée";
        this.loadOrderItem();
      }else if(selectedStatus == "Nouvelle"){
        this.statusSearchText = "nouvelle commande";
        this.loadOrderItem();
      }else if(selectedStatus == "EnLivraison"){
        this.statusSearchText = "en livraison";
        this.loadOrderItem();
      }
    }
  }

  selectStatssus(event: any) {
    // console.log("Iciiiiiiiiiiiiiii...")
    let selectedStatus = event.target.value;
    this.statusSearchText = event.target.value;
    if(selectedStatus == "all"){
      this.statusSearchText = "";
      this.loadOrderItem();
    }else{
      this.statusSearchText = selectedStatus;
      this.loadOrderItem();
    }
  }

  resetCommentForm() {
    this.cancelCommentForm.reset();
  }

  diableCommentButton = false;
  cancelComment() {
    this.diableCommentButton = true;
    let cancelOrderItem = {
      'id' : this.toCancel.id,
      'cancelDetails' : this.cancelCommentForm.controls['comment'].value
    };
   // console.log(cancelOrderItem);

    this.orderService.cancelDeliveryBackoffice(cancelOrderItem).subscribe(rs => {
     // console.log(rs)
      this.resetCommentForm();
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Commande annulée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.loadOrderItem();
        this.close();
      }, error => {
        //console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        })
      }
    )
  }

  close(){
    this.closebutton.nativeElement.click();
  }

  viewOrderItem(co: any) {
    let userCan : User;
    this.currentOrderItem = co;
    this.orderService.getOrderItemById(co.id).subscribe(rs=>{
      this.currentOrderItem = rs;
      this.shopService.getShopByShopId(this.currentOrderItem.productShopID).subscribe(shop => {
        let resultshop : Shop;
        resultshop = shop;
        this.currentOrderItem.sellerLastName = resultshop.sellerId.lastname;
        this.currentOrderItem.sellerFirstName = resultshop.sellerId.firstname;
        this.currentOrderItem.sellerPhoneNumber = resultshop.sellerId.phoneNumber;
        // Vérifier si la commande a été annuler par le BO
        if(this.currentOrderItem.canceledBy && this.currentOrderItem.canceledBy!=''){
          this.userService.getByUSerName(this.currentOrderItem.canceledBy).subscribe(canceledUser=>{
            userCan = canceledUser;
            this.currentOrderItem.canceledByBoUserLastName = userCan.lastname;
            this.currentOrderItem.canceledByBoUserFirstName = userCan.firstname;
            if(this.currentOrderItem.cancelDetails!=null && this.currentOrderItem.cancelDetails != ''){
              // La commande a été annulée par le vendeur
              this.currentOrderItem.canceledByKahpooBackOffice = true;
              this.currentOrderItem.canceledBySeller = false;
              this.currentOrderItem.canceledByCustomer = false;
            }else if(this.currentOrderItem.clientID === userCan.username){
              // La commande a été annulée par le client
              this.currentOrderItem.canceledByKahpooBackOffice = false;
              this.currentOrderItem.canceledByCustomer = true;
              this.currentOrderItem.canceledBySeller = false;
            }else{
              // La commande a été annulée par le vendeur
              this.currentOrderItem.canceledBySeller = true
              this.currentOrderItem.canceledByCustomer = false;
              this.currentOrderItem.canceledByKahpooBackOffice = false;
            }
          });
        }

        //console.log("Détailsdelacommande########");
        //console.log(this.currentOrderItem);
      });
    })
  }
}
